import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { legacyPathnameToAppPathname } from '#utils/document-app-path';

const LEGACY = '/documents';

/**
 * Replaces legacy `/documents/...` locations with canonical `/d/...` (search + hash preserved).
 */
export function DocumentLegacyRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  const target = useMemo(() => {
    if (location.pathname === LEGACY || location.pathname === `${LEGACY}/`) {
      return {
        pathname: '/d',
        search: location.search,
        hash: location.hash,
      };
    }

    return {
      pathname: legacyPathnameToAppPathname(location.pathname),
      search: location.search,
      hash: location.hash,
    };
  }, [location.hash, location.pathname, location.search]);

  useEffect(() => {
    if (
      target.pathname !== location.pathname ||
      target.search !== location.search ||
      target.hash !== location.hash
    ) {
      navigate(target, { replace: true });
    }
  }, [location.hash, location.pathname, location.search, navigate, target]);

  return null;
}
